
riot.tag2('discounts-list', '  <catalog object="Discount" cols="{cols}" allselect="true" reload="true" handlers="{handlers}" store="discounts-list" reorder="true" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(open, &quot;products&quot;, &quot;1000&quot;)}">\n    <yield to="body">\n      <datatable-cell class="{bg-info: row.type==&quot;cumulative&quot;}" name="title"><i class="fa fa-percent" if="{!row.additional}" title="Основная скидка"></i><i class="fa fa-plus" if="{row.additional}" title="Добавочная скидка"></i>&nbsp;{row.title}</datatable-cell>\n      <datatable-cell name="discount">{row.discount} {row.typeDiscount == \'percent\' ? \'%\' : \'р.\'}</datatable-cell>\n      <datatable-cell class="text-left" name="period">{handlers.period(row)}</datatable-cell>\n      <datatable-cell name="summFrom"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.summFrom.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="summTo"><span style="color: #ccc;">{row.nameFront !== null && row.nameFront !== ⁗⁗ ? row.nameFront : ⁗⁗}</span><span> {row.summTo.toFixed(2)}</span><span style="color: #ccc;"> {row.nameFront !== null && row.nameFront !== ⁗⁗ ? ⁗⁗ : row.nameFlang !== null && row.nameFlang !== ⁗⁗ ? row.nameFlang : row.titleCurr}</span></datatable-cell>\n      <datatable-cell name="countFrom"><span if="{row.type!=&quot;cumulative&quot;}">{row.countFrom}</span><span if="{row.type==&quot;cumulative&quot;}">-</span></datatable-cell>\n      <datatable-cell name="countTo"><span if="{row.type!=&quot;cumulative&quot;}">{row.countTo}</span><span if="{row.type==&quot;cumulative&quot;}">-</span></datatable-cell>\n      <datatable-cell name="week"><span if="{row.type!=&quot;cumulative&quot;}">{handlers.getListOfDays(row.week)}</span><span if="{row.type==&quot;cumulative&quot;}">-</span></datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Discount';
self.cols = [{ name: 'title', value: 'Наименование' }, { name: 'discount', value: 'Скидка' }, { name: 'period', value: 'Период' }, { name: 'summFrom', value: 'От суммы' }, { name: 'summTo', value: 'До суммы' }, { name: 'countFrom', value: 'От кол-ва' }, { name: 'countTo', value: 'До кол-ва' }, { name: 'week', value: 'Дни недели' }];

self.handlers = {
    daysOfWeek: ['Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.', 'Вс.'],
    getListOfDays: function getListOfDays(days) {
        var _this = this;

        var items = days.split('');

        var result = items.map(function (item, i) {
            return item == 1 ? _this.daysOfWeek[i] : undefined;
        }).filter(function (item) {
            return item;
        }).join(',');

        return result;
    },
    period: function period(item) {
        var period = '';
        if (item.dateFrom) period = 'с ' + item.dateFrom;
        if (period) period = period + ' - ' + item.dateTo;
        if (!period) period = '-';
        return period;
    }
};

observable.on('discount-reload', function () {
    return self.tags.catalog.reload();
});

self.add = function () {
    riot.route('products/discounts/new');
};

self.open = function (e) {
    riot.route('products/discounts/' + e.item.row.id);
};

self.one('updated', function () {
    self.tags.catalog.tags.datatable.on('reorder-end', function () {
        var _self$tags$catalog$pa = self.tags.catalog.pages,
            current = _self$tags$catalog$pa.current,
            limit = _self$tags$catalog$pa.limit;

        var params = { indexes: [] };
        var offset = current > 0 ? (current - 1) * limit : 0;

        self.tags.catalog.items.forEach(function (item, sort) {
            item.sort = sort + offset;
            params.indexes.push({ id: item.id, sort: sort + offset });
        });

        API.request({
            object: self.collection,
            method: 'Sort',
            data: params,
            notFoundRedirect: false
        });
        self.update();
    });
});
});


// WEBPACK FOOTER //
// ./pages/products/discounts/discounts-list.tag